(() => {
  const THREE_MONTH_PLAN_ID = '3191668799';
  const MONTHLY_PLAN_ID = '3191636031';
  const MULTIPLIER = 3;

  function parseMoney(text) {
    if (!text) return null;

    const match = text
      .replace(/,/g, '')
      .match(/\d+(?:\.\d+)?/);

    return match ? Number(match[0]) : null;
  }

  function getCurrencySymbol(text) {
    if (!text) return '$';

    const match = text.match(/[^\d\s.,-]+/);

    return match ? match[0] : '$';
  }

  function formatMoney(amount, originalText) {
    const symbol = getCurrencySymbol(originalText);
    return `${symbol}${amount.toFixed(2)}`;
  }

  function getUnitPrice(element) {
    if (!element) return null;

    const currentText = element.textContent.trim();
    const lastRenderedTotal = element.dataset.aicRenderedTotal;

    /*
      If the text still equals the total that WE rendered,
      use the original unit price we saved.
    */
    if (
      lastRenderedTotal &&
      currentText === lastRenderedTotal &&
      element.dataset.aicUnitPrice
    ) {
      return {
        value: Number(element.dataset.aicUnitPrice),
        sourceText: element.dataset.aicUnitText || currentText
      };
    }

    /*
      If Appstle changed the price because the product/variant changed,
      treat the newly displayed value as the new single-pouch price.
    */
    const value = parseMoney(currentText);

    if (value === null) return null;

    element.dataset.aicUnitPrice = String(value);
    element.dataset.aicUnitText = currentText;

    return {
      value,
      sourceText: currentText
    };
  }

  function renderThreeMonthTotal(element, unitPrice) {
    if (!element || !unitPrice) return;

    const total = formatMoney(
      unitPrice.value * MULTIPLIER,
      unitPrice.sourceText
    );

    if (element.textContent.trim() !== total) {
      element.textContent = total;
    }

    element.dataset.aicRenderedTotal = total;
  }

  function findThreeMonthInput(widget) {
    /*
      First try the exact Appstle selling-plan ID.
    */
    let input = widget.querySelector(
      `input[name="selling_plan"][value="${THREE_MONTH_PLAN_ID}"]`
    );

    if (input) return input;

    /*
      Fallback: identify the plan by its visible name.
      This keeps the script working if the plan ID ever changes.
    */
    const inputs = widget.querySelectorAll('input[name="selling_plan"]');

    for (const candidate of inputs) {
      const label = widget.querySelector(`label[for="${candidate.id}"]`);

      if (
        label &&
        /3\s*months?\s*subscription/i.test(label.textContent)
      ) {
        return candidate;
      }
    }

    return null;
  }

  function updateThreeMonthPricing() {
    const widgets = document.querySelectorAll(
      '[id^="appstle_subscription_widget"]'
    );

    widgets.forEach((widget) => {
      const input = findThreeMonthInput(widget);

      if (!input) return;

      const label = widget.querySelector(`label[for="${input.id}"]`);

      if (!label) return;

      const regularPrice = label.querySelector(
        '.appstle_sellingPlan_formattedCompareAtPrice'
      );

      const subscriptionPrice = label.querySelector(
        '.appstle_sellingPlan_price'
      );

      const regularUnitPrice = getUnitPrice(regularPrice);
      const subscriptionUnitPrice = getUnitPrice(subscriptionPrice);

      renderThreeMonthTotal(regularPrice, regularUnitPrice);
      renderThreeMonthTotal(subscriptionPrice, subscriptionUnitPrice);
      if (subscriptionUnitPrice) {
        let meta = label.querySelector('.aic-three-month-meta');
if (!meta) {
  meta = document.createElement('div');
  meta.className = 'aic-three-month-meta';
}

const priceRow =
  label.querySelector('.appstle_span_wrapper') ||
  subscriptionPrice.parentElement;

if (priceRow && meta.parentElement !== priceRow) {
  priceRow.insertBefore(meta, priceRow.firstChild);
}

        const perPouch = formatMoney(
          subscriptionUnitPrice.value,
          subscriptionUnitPrice.sourceText
        );

        meta.textContent =
          `3 pouches every 3 months · ${perPouch}/pouch`;
      }  
    });
  }
function findMonthlyInput(widget) {
  let input = widget.querySelector(
    `input[name="selling_plan"][value="${MONTHLY_PLAN_ID}"]`
  );

  if (input) return input;

  const inputs = widget.querySelectorAll('input[name="selling_plan"]');

  for (const candidate of inputs) {
    const label = widget.querySelector(`label[for="${candidate.id}"]`);

    if (
      label &&
      /monthly\s*subscription/i.test(label.textContent)
    ) {
      return candidate;
    }
  }

  return null;
}

function updateMonthlyPricing() {
  const widgets = document.querySelectorAll(
    '[id^="appstle_subscription_widget"]'
  );

  widgets.forEach((widget) => {
    const input = findMonthlyInput(widget);

    if (!input) return;

    const label = widget.querySelector(`label[for="${input.id}"]`);

    if (!label) return;

    const subscriptionPrice = label.querySelector(
      '.appstle_sellingPlan_price'
    );

    const subscriptionUnitPrice = getUnitPrice(subscriptionPrice);

    if (!subscriptionUnitPrice) return;

    let meta = label.querySelector('.aic-monthly-meta');

    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'aic-monthly-meta';
    }

    const priceRow =
      label.querySelector('.appstle_span_wrapper') ||
      subscriptionPrice.parentElement;

    if (priceRow && meta.parentElement !== priceRow) {
      priceRow.insertBefore(meta, priceRow.firstChild);
    }

    const perPouch = formatMoney(
      subscriptionUnitPrice.value,
      subscriptionUnitPrice.sourceText
    );

    meta.textContent =
      `1 pouch every month · ${perPouch}/pouch`;
  });
}
function updateOneTimePricePosition() {
  const widgets = document.querySelectorAll(
    '[id^="appstle_subscription_widget"]'
  );

  widgets.forEach((widget) => {
    const oneTimeBlock = widget.querySelector('.appstle_onetime_block');

    if (!oneTimeBlock) return;

    const nameWrapper = oneTimeBlock.querySelector(
      '.appstle-selling-plan-name-wrapper'
    );

    const cancelText = oneTimeBlock.querySelector('.appstle-cancel-text');

    const detailWrapper = oneTimeBlock.querySelector(
      '.appstle-selling-plan-detail-wrapper'
    );

    const sourcePrice = oneTimeBlock.querySelector(
      '.appstle_onetime_amount'
    );

    if (!nameWrapper || !cancelText || !sourcePrice) return;

    /*
      Keep Appstle's real price element in its original location.
      Appstle expects it there and may rewrite it dynamically.
    */
    if (
      detailWrapper &&
      sourcePrice.parentElement !== detailWrapper
    ) {
      detailWrapper.appendChild(sourcePrice);
    }

    let inlinePrice = nameWrapper.querySelector(
      '.aic-onetime-inline-price'
    );

    if (!inlinePrice) {
      inlinePrice = document.createElement('span');
      inlinePrice.className = 'aic-onetime-inline-price';

      nameWrapper.insertBefore(inlinePrice, cancelText);
    }

    const priceText = sourcePrice.textContent.trim();

    if (priceText) {
      inlinePrice.textContent = priceText;
    }
  });
}
  let updateScheduled = false;

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(() => {
    updateScheduled = false;
    updateThreeMonthPricing();
    updateMonthlyPricing();
    updateOneTimePricePosition();
});
  }

  /*
    Appstle can render after the Shopify page itself has loaded,
    so watch for its widget and for price changes.
  */
  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /*
    Also update when shoppers change subscription options
    or Shopify product variants.
  */
  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'input[name="selling_plan"], input[name="id"], select[name="id"]'
      )
    ) {
      scheduleUpdate();
    }
  });

  scheduleUpdate();
})();
/* =========================================================
   ONE-TIME PURCHASE → AUTO ADD TO CART
   ========================================================= */

let aicOneTimeAutoAddLocked = false;

document.addEventListener(
  'change',
  (event) => {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.name !== 'selling_plan' ||
      !input.closest('.appstle_onetime_block') ||
      !input.checked ||
      aicOneTimeAutoAddLocked
    ) {
      return;
    }

    const widget = input.closest('[id^="appstle_subscription_widget"]');
    if (!widget) return;

    const productForm =
      widget.closest('product-form-component') ||
      document.querySelector('product-form-component');

    if (!productForm) return;

    const addToCartButton = productForm.querySelector(
      'button[name="add"][ref="addToCartButton"]'
    );

    if (!addToCartButton || addToCartButton.disabled) return;

    aicOneTimeAutoAddLocked = true;

    /*
      Give Appstle a moment to finish switching
      the purchase option to One-Time.
    */
    setTimeout(() => {
      addToCartButton.click();

      setTimeout(() => {
        aicOneTimeAutoAddLocked = false;
      }, 1500);
    }, 150);
  },
  true
);